import React, { useMemo } from 'react';
import moment from 'moment';
import './MonthCalendar.sass';

const MonthCalendar = ({ days, onDateSelect, selectedDate, currentMonth }) => {
  // Generate calendar grid
  const calendarDays = useMemo(() => {
    const startOfMonth = currentMonth.clone().startOf('month');
    const endOfMonth = currentMonth.clone().endOf('month');
    const startOfCalendar = startOfMonth.clone().startOf('isoweek');

    const endOfCalendar = endOfMonth.clone().endOf('isoweek');
    const weeksNeeded = Math.ceil(endOfCalendar.diff(startOfCalendar, 'days') / 7);
    const totalDays = weeksNeeded * 7;

    const calendarDays = [];
    const current = startOfCalendar.clone();

    for (let i = 0; i < totalDays; i++) {
      const dayData = days.find(day => day.item.date.isSame(current, 'day'));

      calendarDays.push({
        date: current.clone(),
        isCurrentMonth: current.isSame(currentMonth, 'month'),
        isAvailable: !!dayData && !dayData.disabled,
        isDisabled: !!dayData && dayData.disabled,
        hasAppointments: !!dayData,
        dayData: dayData,
      });

      current.add(1, 'day');
    }

    return calendarDays;
  }, [currentMonth, days]);

  const handleDateClick = calendarDay => {
    if (calendarDay.isAvailable && onDateSelect && calendarDay.dayData) {
      onDateSelect(calendarDay.dayData);
    } else if (calendarDay.isAvailable && onDateSelect) {
      onDateSelect({
        item: {
          date: calendarDay.date,
        },
        select: () => {},
      });
    }
  };

  const weekDays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

  return (
    <div className="month-calendar">
      {/* Week day headers */}
      <div className="month-calendar__header">
        {weekDays.map(day => (
          <div key={day} className="month-calendar__weekday">
            {day}
          </div>
        ))}
      </div>

      {/* Calendar grid */}
      <div className="month-calendar__grid">
        {calendarDays.map((calendarDay, index) => {
          const isSelected =
            selectedDate && calendarDay.date.isSame(selectedDate, 'day') && calendarDay.isAvailable;

          return (
            <button
              key={index}
              className={`month-calendar__day ${
                !calendarDay.isCurrentMonth ? 'month-calendar__day--other-month' : ''
              } ${calendarDay.isAvailable ? 'month-calendar__day--available' : ''} 
               ${!calendarDay.hasAppointments || calendarDay.isDisabled ? 'month-calendar__day--disabled' : ''} ${
                 isSelected ? 'month-calendar__day--selected' : ''
               }`}
              onClick={() => handleDateClick(calendarDay)}
              disabled={!calendarDay.isAvailable}
              aria-label={calendarDay.date.format('dddd D MMMM YYYY')}
            >
              {calendarDay.date.format('D')}
            </button>
          );
        })}
      </div>

      {/* Legend */}
      <div className="month-calendar__legend">
        <div className="month-calendar__legend-item">
          <div className="month-calendar__legend-box month-calendar__legend-box--available"></div>
          <span>Available dates</span>
        </div>
        <div className="month-calendar__legend-item">
          <div className="month-calendar__legend-box month-calendar__legend-box--selected"></div>
          <span>Your selection</span>
        </div>
      </div>
    </div>
  );
};

export default MonthCalendar;
